import { IAttachment } from 'src/app/shared/attachments/models/attachments.model';
import { ICorrectiveActionResponse } from '../models/corrective-action.model';
import { IMaintenanceJob, MaintenanceObjectKind } from '../models/maintenance-job.model';
import { hasCorrectiveActionPerforms } from './has-corrective-action-performs';

export function mapCorrectiveActionToMaintenanceJob(
  correctiveAction: ICorrectiveActionResponse
): IMaintenanceJob {
  const maintenanceJob: IMaintenanceJob = {
    id: correctiveAction.id,
    name: correctiveAction.name,
    description: correctiveAction.description,
    kind: MaintenanceObjectKind.CorrectiveAction,
    component: {
      id: correctiveAction.componentId,
      name: '',
      sfiCode: '',
    },
    jobType: { id: '', name: '' },
    assignmentsWithAccess: correctiveAction.assignmentsWithAccess ?? [],
    positionsWithAccess: correctiveAction.positionsWithAccess ?? [],
    positionGroupsWithAccess: correctiveAction.positionGroupsWithAccess ?? [],
    rolesWithAccess: (correctiveAction.rolesWithAccess ?? []).map((roleId) => ({
      id: roleId,
      name: roleId,
    })),
    responsibleForPositions: correctiveAction.responsibleForPositions ?? [],
    responsibleForPositionGroups: correctiveAction.responsibleForPositionGroups ?? [],
    responsibleForRoles: correctiveAction.responsibleForRoles ?? [],
    alert: correctiveAction.alert,
    runtime: correctiveAction.runtime,
    customForm: correctiveAction.form
      ? { id: correctiveAction.form, name: '' }
      : { id: '', name: '' },
    attachments: (correctiveAction.attachments ?? []) as unknown as IAttachment[],
    draftAvailable: correctiveAction.draftAvailable ?? false,
    performs: correctiveAction.performs ?? [],
    pausable: correctiveAction.pausable ?? true,
    isDisabled: false,
    isCompleted: hasCorrectiveActionPerforms(correctiveAction),
    standardJobTemplate: { id: '', name: '' },
    createdFromStandardJobTemplateVersion: { id: '', name: '' },
    standardJobTemplateDescription: '',
    standardJobTemplateAttachments: '',
    canPerform: false,
  };

  const runtimeId = correctiveAction.runtime?.id ?? correctiveAction.runtimeId;

  if (correctiveAction.dueDate) {
    maintenanceJob.intervalExpiry = {
      interval: 0,
      lastServiceDate: new Date(),
      nextServiceDate: new Date(correctiveAction.dueDate),
    };
  }

  if (runtimeId) {
    maintenanceJob.runTimeExpiry = {
      runtimeId,
      serviceInterval: correctiveAction.dueHours ?? 0,
      runTimeAtLastService: correctiveAction.runTimeAtLastService ?? 0,
    };
  }

  if (
    !maintenanceJob.intervalExpiry &&
    !maintenanceJob.runTimeExpiry &&
    correctiveAction.doneDate
  ) {
    maintenanceJob.oneTimeExpiry = {
      dueDate: new Date(correctiveAction.doneDate),
    };
  }

  return maintenanceJob;
}
